<template>
  <order-list :shopType="1"></order-list>
</template>

<script>

import OrderList from "@view/components/order/order-list.vue";

export default {
  name: "order",
  components: {OrderList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
